import { render } from "./ProductAccessoriesView.vue?vue&type=template&id=03cc300e&scoped=true&ts=true"
import script from "./ProductAccessoriesView.vue?vue&type=script&lang=ts"
export * from "./ProductAccessoriesView.vue?vue&type=script&lang=ts"

import "./ProductAccessoriesView.vue?vue&type=style&index=0&id=03cc300e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cc300e"]])

export default __exports__